import React, { useContext, useEffect, useState } from 'react'
import { mapData } from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import StripeBankContext from '@/product/context/stripe/bank/bankContext'
import AuthContext from '@/product/context/auth/authContext'
import Popup from '../../organisms/Popup'
import UserContext from '@/product/context/user/userContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import auctionContext from '@/custom/context/auction/auctionContext'
import CustomContext from '@/custom/context/custom/customContext'

function BankDetails(props) {
    const authContext = useContext(AuthContext)
    const { user, loadUser } = authContext
    const auctionContexts = useContext(auctionContext)
    const customContext = useContext(CustomContext)
    const { userBankDetails, responseStatus: responseStatusUser } = customContext
    const { bank_details, getAllBankDetails } = auctionContexts
    const [masterBankDetails, setMasterBankDetails] = useState([])
    const [isSelectBank, setIsSelectBank] = useState(false)

    const accountHolderType = [
        { value: 1, show: 'Saving Account' },
        { value: 2, show: 'Current Account' },
    ]

    const validationBank = Yup.object({
        bank_id: Yup.string().required('Required!'),
        branch: Yup.string().required('Required!'),
        account_holder_name: Yup.string().required('Required!'),
        account_number: Yup.number('Number required').required('Required!'),
        account_type: Yup.string()
            .required('required')
            .notOneOf(['', 'Select'], 'Please select a valid account type'),
        ifsc_code: Yup.string()
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format')
            .length(11, 'IFSC code must be exactly 11 characters')
            .required('IFSC code is required'),
        cancelled_cheque: Yup.string().required('Required!'),
    })

    const bankFormik = useFormik({
        initialValues: {
            bank_id: 100001,
            account_holder_name: '',
            account_type: '',
            ifsc_code: '',
            cancelled_cheque: '',
            account_number: '',
            branch: '',
        },
        validationSchema: validationBank,
        onSubmit: (values) => {
            setIsSelectBank(true)
            userBankDetails(values)
        },
    })

    useEffect(() => {
        if (Array.isArray(bank_details?.records) && bank_details?.records?.length > 0) {
            const masterData = bank_details?.records.map((el) => ({
                ...el,
                show: el?.bank_name || '',
                value: el?.bank_id || '',
                id: el?.bank_id || '',
            }))
            setMasterBankDetails(masterData)
        }
    }, [bank_details])

    const bankDetails = [
        {
            label: (
                <>
                    Bank Name<span style={{ color: '#e32' }}>*</span>
                </>
            ),

            type: 'select',
            placeholder: 'Enter Bank name',
            class: 'col-sm-6 col-md-6 col-12',
            upperLabel: true,
            name: 'bank_id',
            autoFocus: true,
            options: masterBankDetails,
            formik: bankFormik,
        },
        {
            label: (
                <>
                    Branch Name<span style={{ color: '#e32' }}>*</span>
                </>
            ),
            type: 'text',
            placeholder: 'Enter Branch name',
            class: 'col-sm-6 col-md-6 col-12',
            upperLabel: true,
            name: 'branch',
            autoFocus: true,
            formik: bankFormik,
        },
        {
            label: (
                <>
                    Account Holder Name<span style={{ color: '#e32' }}>*</span>
                </>
            ),

            type: 'text',
            upperLabel: true,
            placeholder: 'Enter account holder name',
            class: 'col-sm-6 col-md-6 col-12',
            name: 'account_holder_name',
            autoFocus: true,
            formik: bankFormik,
        },
        {
            label: (
                <>
                    Account Number<span style={{ color: '#e32' }}>*</span>
                </>
            ),
            type: 'string',
            placeholder: 'Enter account number',
            name: 'account_number',
            upperLabel: true,
            class: 'col-sm-6 col-md-6 col-12',
            formik: bankFormik,
        },
        {
            label: (
                <>
                    IFSC Code / SWIFT Code
                    <span style={{ color: '#e32' }}>*</span>
                </>
            ),

            type: 'string',
            placeholder: 'Enter IFSC / SWIFT Code',
            name: 'ifsc_code',
            class: 'col-sm-6 col-md-6 col-12',
            formik: bankFormik,
            upperLabel: true,
        },
        {
            label: (
                <>
                    Account Type
                    <span style={{ color: '#e32' }}>*</span>
                </>
            ),
            type: 'select',
            options: accountHolderType,
            upperLabel: true,
            placeholder: 'Enter account holder type',
            class: 'col-sm-6 col-md-6 col-12',
            name: 'account_type',
            formik: bankFormik,
        },
        {
            label: 'Cancelled Cheque',
            type: 'uploadDropZone',
            showFileName: true,
            upperLabel: true,
            placeholder: 'Enter Cancelled Cheque',
            class: 'col-12',
            upperLabel: true,
            name: 'cancelled_cheque',
            titleText: 'Cancelled Cheque',
            formik: bankFormik,
        },
    ]
    useEffect(() => {
        if (responseStatusUser && responseStatusUser.status === 'success' && isSelectBank) {
            props.function(false, 'new', null)
            setIsSelectBank(false)
            loadUser()
        }
    }, [responseStatusUser])

    useEffect(() => {
        if (props.data.status === 'update') {
            let bankData = props.data.data
            bankFormik.setFieldValue('account_type', bankData?.account_type)
            bankFormik.setFieldValue('branch', bankData?.branch)
            bankFormik.setFieldValue('account_holder_name', bankData?.account_holder_name)
            bankFormik.setFieldValue('id', bankData?.id)
            bankFormik.setFieldValue('bank_id', bankData?.bank_id)
            bankFormik.setFieldValue('cancelled_cheque', [bankData?.cancelled_cheque])
            bankFormik.setFieldValue('ifsc_code', bankData?.ifsc_code)
            bankFormik.setFieldValue('account_number', bankData?.account_number)
        }
    }, [props])

    return (
        <>
            <Popup
                open={props.data.popup}
                size="md"
                handleClose={() => props.function(false, 'new', null)}
                modaltitle={props.data.status === 'new' ? 'Add Bank Details' : 'Edit Bank Details'}
            >
                <div className="bankDetails">
                    <form onSubmit={bankFormik.handleSubmit} autoComplete="nofill">
                        <div className="row">{Object.values(mapData(bankDetails))}</div>
                        <div className="col-12">
                            <PrimaryButton
                                id="bankDetails"
                                // disabled={disabled}
                                onClick={() => {
                                    bankFormik.handleSubmit()
                                }}
                                btnSize="large"
                                // type="submit"
                                label={'Submit'}
                            />
                        </div>
                    </form>
                </div>
            </Popup>
        </>
    )
}

export default BankDetails
